<div class="dashboard">
    <div class="container-fluid p-0">
        <div class="hero-image"></div>
    </div>
    <router-outlet></router-outlet>
</div>